/* eslint-disable */
import type { Money } from "../../common/currency.pb";

/**
 * A customer's display balance. This is similar to squareup.franklin.api.Instrument, but can be
 * computed without full access to instrument information.
 */
export interface BalanceSnapshot {
  /** The instrument token that this balance corresponds to. */
  instrument_token?: string;
  /** The version of the balance for asynchronous updates. */
  version?: number;
  balance?: Money;
  /** The absence of this field means we should treat the balance as "primary" */
  type?: BalanceSnapshotType;
}

/** The types of balances that appear in BalanceSnapshots */
export enum BalanceSnapshotType {
  /** PRIMARY - The primary "Cash Balance". There should be only one of these per currency. */
  PRIMARY = "PRIMARY",
  /**
   * SECONDARY - A secondary balance. Used for Savings Folders or other, similar balances.
   * There may be many of these balances per currency.
   */
  SECONDARY = "SECONDARY",
}
